import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LucideLink } from '@lucide/angular';

@Component({
  selector: 'app-copy-location-button',
  imports: [LucideLink, MatButtonModule, MatTooltipModule],
  templateUrl: './copy-location-button.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./copy-location-button.scss'],
})
export class CopyLocationButton {
  /** L'adresse à copier, quand ce qu'on montre n'est pas la page elle-même : un avenant. */
  readonly url = input<string | null>(null);

  handleClick() {
    navigator.clipboard.writeText(this.url() ?? window.location.href);
  }
}
